__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/52657cad3e54b12ee5ada5aba8301b8053be8bbd40558be5cd92b03b/";